export const getOptimisedImageUrl = (url: string, width: number) => {
  return url.replace('public', `width=${width}`);
};
